import contentWithDrawer from "../components/contentWithDrawer";
import DrawerContent from "../components/ViewRun/ViewRunDrawerContent";
import MainContent from "../components/ViewRun/ViewRunMainContent";

const ViewRun = contentWithDrawer(MainContent, DrawerContent);

export default ViewRun;
